// extracted by mini-css-extract-plugin
export var typingIndicator = "_kn-0";